$('.acc-toggle').click(function(e) {
  $(this).toggleClass('active');
  $('.acc-toggle').not(this).removeClass('active');
  	e.preventDefault();
    var $this = $(this);
    if ($this.next().hasClass('show')) {
        $this.next().removeClass('show');
        $this.next().slideUp(350);
        //$(".acc-toggle h6").removeClass("active");
    } else {
        $this.parent().parent().find('li .inner').removeClass('show');
        $this.parent().parent().find('li .inner').slideUp(350);
        $this.next().toggleClass('show');
        $this.next().slideToggle(350);
        //$(".acc-toggle h6").addClass("active");
    }
});



// Accordion script start 
function initAccordion(scope = document) {
  const triggers = scope.querySelectorAll('[data-toggle="collapse"]');

  if (!window.__accordionActiveByParent) {
    window.__accordionActiveByParent = new Map();
  }

  const activeByParent = window.__accordionActiveByParent;

  triggers.forEach(trigger => {
    if (trigger.dataset.accordionBound === 'true') return;

    const targetSel = trigger.dataset.target;
    if (!targetSel) return;

    const content = scope.querySelector(targetSel) || document.querySelector(targetSel);
    if (!content) return;

    trigger.collapseTarget = content;
    trigger.dataset.accordionBound = 'true';

    const parentSel = content.dataset.parent || null;

    if (content.classList.contains('is-active')) {
      if (parentSel) activeByParent.set(parentSel, trigger);
    }

    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      toggleAccordion(trigger, activeByParent);
    });

    content.addEventListener('transitionend', function (e) {
      if (e.propertyName === 'height' && content.classList.contains('is-active')) {
        content.style.height = 'auto';
      }
    });
  });
}

function toggleAccordion(trigger, activeByParent) {
  const content = trigger.collapseTarget;
  if (!content) return;

  const parentSel = content.dataset.parent || null;

  if (content.classList.contains('is-active')) {
    closeAccordion(trigger);
    if (parentSel && activeByParent.get(parentSel) === trigger) {
      activeByParent.delete(parentSel);
    }
    return;
  }

  if (parentSel) {
    const activeToggle = activeByParent.get(parentSel);
    if (activeToggle && activeToggle !== trigger) {
      closeAccordion(activeToggle);
    }
    activeByParent.set(parentSel, trigger);
  }

  openAccordion(trigger);
}

function closeAccordion(trigger) {
  const content = trigger.collapseTarget;
  if (!content) return;

  content.style.height = content.scrollHeight + 'px';

  requestAnimationFrame(() => {
    content.style.height = '0px';
    content.classList.remove('is-active');
  });

  trigger.classList.remove('is-active');
}

function openAccordion(trigger) {
  const content = trigger.collapseTarget;
  if (!content) return;

  content.style.height = '0px';
  content.classList.add('is-active');
  trigger.classList.add('is-active');

  requestAnimationFrame(() => {
    content.style.height = content.scrollHeight + 'px';
  });
}

document.addEventListener('DOMContentLoaded', function () {
  initAccordion();
});



// video popup script
document.addEventListener("DOMContentLoaded", function () {
  const popup = document.getElementById("reviewVideoPopup");
  const frame = document.getElementById("reviewVideoFrame");
  if (!popup || !frame) return;

  document.addEventListener("click", function (e) {
    const btn = e.target.closest(".video-trigger");
    if (!btn) return;

    const videoType = btn.dataset.videoType || "";
    const uploadSrc = btn.dataset.videoSrc || "";
    const url = btn.dataset.videoUrl || "";
    const videoLayout = btn.dataset.videoLayout || "landscape";
    let html = "";

    popup.classList.remove("is-landscape", "is-portrait");
    popup.classList.add(videoLayout === "portrait" ? "is-portrait" : "is-landscape");

    // Default aspect ratio from the layout flag (used for embeds and until an uploaded video reports its real size)
    popup.style.setProperty("--video-aspect", videoLayout === "portrait" ? "0.5625" : "1.7778");

    if (videoType === "upload" && uploadSrc) {
      html = `
        <video class="popup-video" autoplay playsinline controls>
          <source src="${uploadSrc}" type="video/mp4">
        </video>
      `;
    } else if (videoType === "url" && url) {
      if (url.includes("youtube") || url.includes("youtu.be")) {
        let id = "";

        if (url.includes("v=")) {
          id = url.split("v=")[1].split("&")[0];
        } else {
          id = url.split("/").pop().split("?")[0];
        }

        html = `
          <iframe
            src="https://www.youtube.com/embed/${id}?autoplay=1&mute=1&playsinline=1&rel=0"
            allow="autoplay; encrypted-media"
            allowfullscreen>
          </iframe>
        `;
      } else if (url.includes("vimeo")) {
        const id = url.split("/").pop().split("?")[0];
        html = `
          <iframe
            src="https://player.vimeo.com/video/${id}?autoplay=1&muted=1"
            allow="autoplay; fullscreen"
            allowfullscreen>
          </iframe>
        `;
      } else {
        html = `
          <video class="popup-video" autoplay muted playsinline controls>
            <source src="${url}" type="video/mp4">
          </video>
        `;
      }
    } else {
      return;
    }

    frame.innerHTML = html;
    popup.classList.add("active");
    document.body.classList.add("overflow-hidden");

    const video = frame.querySelector(".popup-video");
    if (video) {
      video.muted = true;
      video.playsInline = true;

      // Size the modal to the video's real aspect ratio so it fills the screen for both orientations
      video.addEventListener("loadedmetadata", function () {
        if (video.videoWidth && video.videoHeight) {
          popup.style.setProperty("--video-aspect", (video.videoWidth / video.videoHeight).toString());
        }
      });

      const playPromise = video.play();
      if (playPromise !== undefined) {
        playPromise.catch(function (error) {
          console.log("Autoplay blocked:", error);
        });
      }
    }
  });

  function closeVideo() {
    const video = frame.querySelector(".popup-video");
    if (video) {
      video.pause();
      video.currentTime = 0;
    }

    popup.classList.remove("active", "is-landscape", "is-portrait");
    frame.innerHTML = "";
    document.body.classList.remove("overflow-hidden");
  }

  const overlay = popup.querySelector(".review-video-popup__overlay");
  const closeBtn = popup.querySelector(".review-video-popup__close");

  if (overlay) overlay.addEventListener("click", closeVideo);
  if (closeBtn) closeBtn.addEventListener("click", closeVideo);

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && popup.classList.contains("active")) {
      closeVideo();
    }
  });
});